<template>
    <div v-if="userStore.user.myfreescorenow" class="card match-height">
        <div class="card-body px-0 py-75">
            <div class="row justify-content-center mx-auto">
                <div class="col-md-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                        <label class="txt-green" for="mfsn_username">
                            {{ localizationStore.translate('myfreescorenow.input.one.label') }}
                        </label>
                        <input
                            type="text"
                            class="form-control border-primary border-darken-1 mx-auto"
                            name="mfsn_username"
                            :placeholder="localizationStore.translate('myfreescorenow.input.one.placeholder')"
                            v-model="userStore.user.myfreescorenow.mfsn_username"
                        />
                    </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                        <label class="txt-green" for="mfsn_password">
                            {{ localizationStore.translate('myfreescorenow.input.two.label') }}
                        </label>
                        <input
                            type="password"
                            class="form-control border-primary border-darken-1"
                            name="mfsn_password"
                            :placeholder="localizationStore.translate('myfreescorenow.input.two.placeholder')"
                            v-model="userStore.user.myfreescorenow.mfsn_password"
                        />
                    </div>
                </div>
            </div>
            <div class="col-12 text-center d-flex flex-sm-row flex-column justify-content-center">
                <button type="submit" class="btn btn-primary mr-md-1 mb-1 mb-sm-0" @click.prevent="updateMFSNCredentials">
                    {{ localizationStore.translate('myfreescorenow.button.one.text') }}
                </button>
                <button @click.once="fetchReport" type="button" class="btn btn-outline-primary">
                    <span v-if="showloading != true">
                        <vue-feather size="12" type="bar-chart-2" class="mr-25" />
                        <span>
                            {{ localizationStore.translate('myfreescorenow.button.two.text') }}
                        </span>
                    </span>
                    <span  v-else>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="ml-25 align-middle">
                            {{ localizationStore.translate('myfreescorenow.button.two.text.updating') }}
                        </span>
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { ref } from 'vue'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../../stores/UserStore.js'
import { useReportStore } from '../../../../stores/ReportStore.js'
export default {
    setup() {
        return {
            localizationStore : useLocalizationStore(),
            userStore : useUserStore(),
            reportStore: useReportStore(),
            team: ref(),
            client: ref(),
            showloading: ref()
        }
    },
    watch: {
    },
    mounted(){
    },
    methods : {
        updateMFSNCredentials() {
            const route = this.$router.resolve(
                {
                    name: 'update-smart-credit-info',
                    params: {
                        client: this.$route.params.client,
                        team: this.$route.params.team
                    }
                }
            ).href;
            axios.put(
                route,
                {
                    mfsn_username : this.userStore.user.myfreescorenow.mfsn_username,
                    mfsn_password : this.userStore.user.myfreescorenow.mfsn_password,
                    type: this.reportStore.myfreescorenow
                }
            ).then(({data})=>{
                if(data.error != true){
                    toastr.success(data.message, 'myFreeScorenow Report Success')
                }else{
                    toastr.error('Your myFreeScorenow Login Info is Not Updated.','myFreeScorenow Report error')
                }
            })
        },
        fetchReport() {
            let $this = this;
            this.showloading = true;
            const route = this.$router.resolve(
                {
                    name: 'fetch-report',
                    params: {
                        client: this.$route.params.client,
                        team: this.$route.params.team
                    }
                }
            ).href;
            axios.get(
                route,
                {
                    params: {
                        type: this.reportStore.myfreescorenow
                    }
                }
            ).then(({data}) => {
                if (data.error != true) {
                    toastr.info(data.message,'Fetch Report Success')
                } else {
                    toastr.error(data.message,'Error')
                }
            })
           .catch(function (error) {
                $this.showloading = false;
                toastr.error(error.response.statusText, 'Error!');
            });
        }
    }

}
</script>
